import { onMounted, onUnmounted, ref } from 'vue';
import type { Observable, Subscription } from 'rxjs';
import { ServerSentEventService } from '@/api/server-sent-event.service';
import type { CallDto } from '@carvia/ros-client-types';

export function useCalls() {
  const calls = ref<CallDto[]>([]);
  const error = ref<string | null>(null);
  const isConnected = ref(false);
  let sub: Subscription | null = null;

  const sse = new ServerSentEventService<CallDto[]>('/phone/events');

  function start() {
    if (sub) return;
    error.value = null;
    const stream: Observable<CallDto[]> = sse.open();
    sub = stream.subscribe({
      next: (evt) => {
        isConnected.value = true;
        calls.value = evt;
      },
      error: (err) => {
        error.value = typeof err === 'string' ? err : (err?.message ?? 'Connection error');
        isConnected.value = false;
      },
      complete: () => {
        isConnected.value = false;
      },
    });
  }

  function stop() {
    if (sub) {
      sub.unsubscribe();
      sub = null;
      sse.close();
      isConnected.value = false;
    }
  }

  onMounted(start);
  onUnmounted(stop);

  return { calls, isConnected, error };
}
